import { AlumniInteractionType, AlumniStatus } from '../../types/alumni';

export const ALUMNI_STATUS_LABELS: Record<AlumniStatus, string> = {
  EMPLOYED: 'Employed',
  SELF_EMPLOYED: 'Self-employed',
  FURTHER_STUDIES: 'Further studies',
  SEEKING_OPPORTUNITIES: 'Seeking opportunities',
  RETIRED: 'Retired',
  OTHER: 'Other',
};

export const ALUMNI_STATUS_COLORS: Record<AlumniStatus, 'success' | 'info' | 'warning' | 'default' | 'secondary'> = {
  EMPLOYED: 'success',
  SELF_EMPLOYED: 'success',
  FURTHER_STUDIES: 'info',
  SEEKING_OPPORTUNITIES: 'warning',
  RETIRED: 'default',
  OTHER: 'default',
};

export const INTERACTION_LABELS: Record<AlumniInteractionType, string> = {
  CALL: 'Phone call',
  EMAIL: 'Email',
  WHATSAPP: 'WhatsApp',
  MEETING: 'Meeting',
  CAREER_UPDATE: 'Career update',
  FOLLOW_UP_NOTE: 'Follow-up note',
  OTHER: 'Other',
};

export const DUPLICATE_REASON_LABELS: Record<string, string> = {
  email: 'same email',
  phone: 'same contact number',
  studentNumber: 'same Student ID',
  student: 'same student',
};

export const SOURCE_LABELS: Record<string, string> = {
  MANUAL: 'Added manually',
  GRADUATION: 'From graduation',
  IMPORT: 'Imported',
};

/** "YYYY-MM-DD" for a date input, from an ISO string. */
export const toDateInput = (iso: string | null | undefined) => (iso ? iso.slice(0, 10) : '');

export const formatDay = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
